// App.js
import React from "react";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import AppleLogin from "react-apple-login";
import { useToast } from "@/hooks/use-toast";
import { useLocation } from "wouter";
import { useDispatch } from 'react-redux';
import { login } from "@/Redux/authSlice";
import API_URL, { APPLE_CLIENT_ID, APPLE_REDIRECT_URI } from "@/config";
import axios from "axios";
import { Grid } from "@mui/material";

export default function GoogleSign() {
    const { toast } = useToast();
    const [location, navigate] = useLocation();
    const dispatch = useDispatch();

    const sendCredentialToBackend = async (credential: any) => {
        try {
            await axios.post(API_URL + "/api/auth/google-login", { token: credential }
            )
                .then((res) => {
                    if (res?.data?.success) {
                        dispatch(login({ user: res?.data.user }));
                        toast({
                            variant: "success",
                            title: "Login successful!",
                            description: "Redirecting to dashboard...",
                        });
                        sessionStorage.setItem("user", JSON.stringify(res?.data?.user));
                        sessionStorage.setItem("token", res?.data?.token);
                        navigate("/");
                    }
                    else {
                        toast({
                            variant: "destructive",
                            title: "Login failed!",
                            description: res?.data?.message,
                        });
                    }
                })
                .catch((error) => {
                    toast({
                        variant: "destructive",
                        title: "Login failed!",
                        description: error?.response?.data?.message,
                    });
                })
        } catch (error: any) {
            toast({
                variant: "destructive",
                title: "Login failed!",
                description: error?.response?.data?.message,
            })
        }
    };

    const handleAppleSuccess = async (response: any) => {
        try {
            // response includes authorization: { id_token, code } and maybe user on first sign-in
            const idToken = response?.authorization?.id_token;
            if (!idToken) {
                return toast({ variant: "destructive", title: "Apple Login failed", description: "No id_token received" });
            }
            const res = await axios.post(API_URL + "/api/auth/apple-login", { id_token: idToken });
            if (res?.data?.success) {
                dispatch(login({ user: res.data.user }));
                toast({ variant: "success", title: "Login successful!", description: "Redirecting to dashboard..." });
                sessionStorage.setItem("user", JSON.stringify(res.data.user));
                sessionStorage.setItem("token", res.data.token);
                navigate("/");
            } else {
                toast({ variant: "destructive", title: "Login failed!", description: res?.data?.message });
            }
        } catch (error: any) {
            toast({ variant: "destructive", title: "Login failed!", description: error?.response?.data?.message || "Unknown error" });
        }
    };

    // Handle errors
    const handleError = (err: any) => {
        console.error("Login Failed:", err);
        toast({ description: "Login Failed ❌" });
    };

    return (
        <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 6 }}>

                <GoogleOAuthProvider clientId="652114524337-uaq7ar04lq3i7llqmukb2la9eomp7i5v.apps.googleusercontent.com">
                    <div style={{ textAlign: "center" }}>
                        <GoogleLogin
                            onSuccess={(credentialResponse) => {
                                sendCredentialToBackend(credentialResponse.credential);
                            }}
                            onError={() => {
                                console.log("Login Failed");
                            }}
                        />
                    </div>
                </GoogleOAuthProvider>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
                <AppleLogin
                    clientId={APPLE_CLIENT_ID}
                    redirectURI={APPLE_REDIRECT_URI}
                    usePopup={true}
                    callback={handleAppleSuccess}
                    // onFailure={handleError}
                    render={(props) => (
                        <button
                            onClick={props.onClick}
                            className="bg-black text-white rounded-lg px-4 py-2 w-full"
                        >
                             Sign in with Apple
                        </button>
                    )}
                />
            </Grid>
        </Grid>
    );
}
